<section class="login">
  <form [formGroup]="loginForm" class="container type--xs login__container">
    <h1 class="login__title">login</h1>

    <mat-form-field class="full--width">
      <input matInput type="email" placeholder="Email address" formControlName="email" />
    </mat-form-field>

    <mat-form-field class="full--width">
      <input matInput type="password" placeholder="Password" formControlName="password" />
    </mat-form-field>

    <mat-checkbox matInput label="Remember me" formControlName="persistent" [disableRipple]="true" color="primary">
      Remember me
    </mat-checkbox>

    <p class="error-message" *ngIf="serverError">
      {{ serverError }}
    </p>
    <div class="login__toolbar">
      <button class="button login__toolbar__button" [disabled]="loginForm.invalid" [class.is--loading]="loading" (click)="login()">
        Log in
      </button>
      <a [routerLink]="['/', 'login', 'forgot-password']" class="link login__toolbar__link">Forgot your password?</a>
    </div>
  </form>
</section>
